import { render } from "./Menu_fitbar.vue?vue&type=template&id=7280456e"
import script from "./Menu_fitbar.vue?vue&type=script&lang=js"
export * from "./Menu_fitbar.vue?vue&type=script&lang=js"

import "./Menu_fitbar.vue?vue&type=style&index=0&id=7280456e&scope=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__